import { jsx as o, jsxs as r, Fragment as I } from "react/jsx-runtime";
import F, { useRef as O, useState as _, useEffect as $ } from "react";
import { styled as a, css as e } from "styled-components";
import { g as H } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { m as s } from "../chunks/breakpoints.907eaecd.js";
import { R as k } from "../chunks/index.6d6da1e3.js";
import { R as D } from "../chunks/NavBar.71e21263.js";
import { RangoImage as G } from "./Image.js";
import { RangoTag as E } from "./Tag.js";
import { R as P } from "../chunks/Heading.2a0f9b41.js";
import { R as X } from "../chunks/Paragraph.60dac1f9.js";
import { RangoButtonIconContainer as Y, ButtonIconContainerSize as W } from "./ButtonIconContainer.js";
const c = {
  SLOT: "slot",
  FLOW: "flow",
  PROMOTION: "promotion"
}, m = {
  SM: "sm",
  LG: "lg"
};
var n = /* @__PURE__ */ ((t) => (t.LEFT = "left", t.RIGHT = "right", t.TOP = "top", t.BOTTOM = "bottom", t))(n || {});
const q = a.div.withConfig({
  displayName: "DrawerContainer",
  componentId: "sc-1y91je1-0"
})(["position:fixed;opacity:0;pointer-events:none;top:0;right:0;width:100%;height:100%;overflow:hidden;transition:background 0.3s ease-in-out,opacity 0.5s ease-in-out;transition-delay:0.1s;z-index:6;", " ", ""], ({
  open: t
}) => t && `   pointer-events: auto;
        opacity: 1;
        ${H}
    `, ({
  $closing: t
}) => t && `
        opacity: 1;
        background: inherit;
    `), J = a.div.withConfig({
  displayName: "Drawer",
  componentId: "sc-1y91je1-1"
})(["position:absolute;display:flex;flex-direction:column;pointer-events:auto;height:100vh;transition:all 0.3s ease-in-out;overflow:hidden;background:var(--elements-bg-color-01);overflow-y:auto;", " ", " ", " ", ""], (t) => K(t.size), ({
  $anchor: t
}) => {
  switch (t) {
    case n.LEFT:
      return e`
          left: 0;
          transform: translateX(-100%);
        `;
    case n.RIGHT:
      return e`
          right: 0;
          transform: translateX(100%);
        `;
    case n.TOP:
      return e`
          top: 0;
          transform: translateY(-100%);
        `;
    case n.BOTTOM:
      return e`
          bottom: 0;
          transform: translateY(100%);
        `;
  }
}, ({
  open: t
}) => t && e`
    transform: translate(0);
  `, ({
  type: t
}) => t === "promotion" && e`
      ${g} {
        margin: 0;
        padding: 0;
      }
    `), K = (t) => {
  if (t === m.SM)
    return e`
      width: 40%;
      max-width: 567px;
      ${s.md(e`
        width: 60%;
        max-width: 864px;
      `)}
      ${s.sm(e`
        width: 100%;
        max-width: 100%;
      `)}
    `;
  if (t === m.LG)
    return e`
      width: 60%;
      max-width: 864px;
      ${s.sm(e`
        width: 100%;
        max-width: 100%;
      `)}
    `;
}, Q = a(D).withConfig({
  displayName: "NavBar",
  componentId: "sc-1y91je1-2"
})(["flex:1 0 auto;"]), g = a.div.withConfig({
  displayName: "Content",
  componentId: "sc-1y91je1-3"
})(["height:100%;margin-top:var(--size-5x);margin-bottom:var(--size-5x);padding-left:var(--spacing-5x);padding-right:var(--spacing-5x);overflow-y:auto;"]), U = a(k).withConfig({
  displayName: "FixedBar",
  componentId: "sc-1y91je1-4"
})(["margin-top:auto;min-height:var(--size-12x);"]), V = a(Y).withConfig({
  displayName: "ButtonClose",
  componentId: "sc-1y91je1-5"
})(["position:absolute !important;top:var(--spacing-5x);right:var(--spacing-5x);", ""], s.sm(e`
    top: var(--spacing-3x);
    right: var(--spacing-3x);
  `)), Z = a.div.withConfig({
  displayName: "PromotionContainer",
  componentId: "sc-1y91je1-6"
})(["display:flex;flex-direction:column;padding:var(--spacing-3x);"]), A = a(G).withConfig({
  displayName: "Image",
  componentId: "sc-1y91je1-7"
})(["border-radius:var(--border-radius-none);height:auto;"]), tt = a(E).withConfig({
  displayName: "Tag",
  componentId: "sc-1y91je1-8"
})(["flex:1 0 auto;margin-bottom:var(--spacing-1x);"]), et = a(P).withConfig({
  displayName: "Heading",
  componentId: "sc-1y91je1-9"
})(["flex:1 0 auto;margin-bottom:var(--spacing-2x);"]), at = a(X).withConfig({
  displayName: "Paragraph",
  componentId: "sc-1y91je1-10"
})(["flex:1 0 auto;margin-bottom:var(--spacing-3x);"]), ot = F.forwardRef(({
  open: t = !1,
  anchor: R = n.RIGHT,
  closeOnOverlayClick: T = !1,
  type: d = c.SLOT,
  size: N = m.SM,
  navbar: l,
  fixedbarProps: p,
  imageProps: B,
  tagProps: f,
  buttonCloseProps: i,
  headingProps: h,
  paragraphProps: u,
  onClose: y,
  onConfirm: j,
  onCancel: S,
  children: x,
  ...M
}, nt) => {
  const w = O(), v = O(null), [b, C] = _(!1);
  $(() => {
    w.current === !0 && t === !1 && (C(!0), setTimeout(() => C(!1), 300)), w.current = t;
  }, [t]);
  const z = () => d === c.PROMOTION ? /* @__PURE__ */ r(I, { children: [
    /* @__PURE__ */ o(V, { size: W.SM, icon: "CloseLine", destination: i.destination, element_parent: i.element_parent, element_type: i.element_type, onClick: y }),
    /* @__PURE__ */ o(A, { ...B }),
    /* @__PURE__ */ r(Z, { children: [
      f && /* @__PURE__ */ o(tt, { ...f }),
      h && /* @__PURE__ */ o(et, { ...h }),
      u && /* @__PURE__ */ o(at, { ...u }),
      /* @__PURE__ */ o(g, { children: x })
    ] })
  ] }) : /* @__PURE__ */ r(I, { children: [
    l && /* @__PURE__ */ o(Q, { buttonCloseProps: i, ...l }),
    /* @__PURE__ */ o(g, { children: x })
  ] });
  return /* @__PURE__ */ o(q, { ref: v, open: t, $closing: b, onClick: T ? (L) => {
    L.target === v.current && y();
  } : void 0, "data-testid": "rango-drawer", "data-rango-component": "rango-drawer", "data-is-rango": !0, ...M, children: /* @__PURE__ */ r(J, { open: t, type: d, $anchor: R, size: d === c.PROMOTION ? m.SM : N, children: [
    z(),
    p && /* @__PURE__ */ o(U, { ...p, onConfirm: j, onCancel: S })
  ] }) });
});
ot.displayName = "RangoDrawer";
export {
  ot as RangoDrawer
};
